module.exports = __webpack_public_path__ + "static/andy-33dbe3dc706b27b780de548fc53540d0.png";